const getClientAlias = () => {
  const match = window.location.pathname.match(/\/c\/([^/]+)/);
  return match ? match[1] : '_default';
};

const getStorageKey = () => `inc_attribution:${getClientAlias()}`;

const ATTRIBUTION_PARAMS = [
  // Google Ads
  'gclid',
  'gbraid',
  'wbraid',
  // UTM
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  // Other ad platforms
  'fbclid',
  'msclkid',
  'dclid',
  'ttclid',
  'li_fat_id',
];

export const captureAttributionParams = () => {
  try {
    const key = getStorageKey();
    if (sessionStorage.getItem(key)) return;

    const params = new URLSearchParams(window.location.search);
    const attribution = {};

    ATTRIBUTION_PARAMS.forEach(paramName => {
      const value = params.get(paramName);
      if (value) attribution[paramName] = value;
    });

    if (Object.keys(attribution).length > 0) {
      sessionStorage.setItem(key, JSON.stringify(attribution));
    }
  } catch {
    // sessionStorage may be unavailable (e.g. private browsing restrictions)
  }
};

export const getAttributionParams = () => {
  try {
    const stored = sessionStorage.getItem(getStorageKey());
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
